import React from "react";

import { wrap } from "./RydTestbedWrap";
import { UserAccountInfo, UserAccountPanel } from "../components/panels/UserAccountPanel";
import { RydUser, RydUserAccount } from "../accounts/model";
import { ApiClient, ApiFactory } from "../ApiClient";

export function UserAccountPanelTestbed() {

    const [customerNumber, setCustomerNumber] = React.useState("CUST-001");

    const [account, setAccount] = React.useState<RydUserAccount>({
        user: {
            id: 1,
            customerNumber: "CUST-001",
            name: "Test User",
            email: "max@mustermann",
            username: "max"
        },
        balance: 100.0,
        status: "active" as const,
        createdAt: new Date(),
    });

    const API = ApiFactory.create();
    React.useEffect(() => {
        if (!customerNumber) return;
        // Simulate fetching user account data from an API
        API.getUserAccount(customerNumber).then((fetchedAccount: RydUserAccount) => {
            setAccount(fetchedAccount);
        }).catch((error) => {
            console.error("Failed to fetch user account:", error);
        });
    }, [API, customerNumber]);

    return wrap(<>
        <h1>UserAccountPanel Testbed</h1>
        From api: <input
            type="text"
            value={customerNumber}
            onChange={(e) => setCustomerNumber(e.target.value)}
            />

        <table>
            <tr><td>
                <UserAccountInfo
                    account={account}
                    setAccount={setAccount}
                />
            </td>
                <td><pre>{JSON.stringify(account, null, 2)}</pre></td>
            </tr>
        </table>
    </>);
}